// src/sot/tokens/typography.js
// AfriMed type scale — SSOT
// Spec source: Headline Small = Inter 24/32 weight 400 (tracking 0).
export const type = {
  /* Titles */
  titleLarge:   { size: 22, line: 28, weight: 400 }, // used by some legacy screens
  titleMedium:  { size: 16, line: 24, weight: 500 },

  /* Headlines */
  headlineSmall:{ size: 24, line: 32, weight: 400 }, // ← new per spec

  /* Body */
  bodyLarge:    { size: 16, line: 24, weight: 400 },
  bodyMedium:   { size: 14, line: 20, weight: 400 },

  /* Labels / Overlines */
  labelMedium:  { size: 12, line: 16, weight: 500 },
};